import config from '@/const/config';
import ClientSDK from '@hb/wisdom-config-sdk';

let client = null;
// eslint-disable-next-line import/prefer-default-export
export function clientSDK(force = false) {
  if (force || !client) {
    client = new ClientSDK({
      env: config.env === 'dev' ? 'fat' : config.env,
      project: 'AppPlatformH5',
    });
  }
  return client;
}
